export const layoutStyles = {
	root: {}
};
